
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_7046_253788)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.002 3.06849C10.1626 3.06849 5.22267 6.95983 3.61662 12.2821H6.89716C8.41986 8.71861 11.931 6.13696 16.0017 6.13696C18.9551 6.13696 21.6091 7.42878 23.4206 9.47351L21.1243 11.5085C19.8719 10.0949 18.0427 9.20546 16.0017 9.20546C12.4283 9.20546 9.50062 11.8808 9.19887 15.3486H7.06762V15.3506H1.53757V15.34H0C0.441105 6.8966 7.45069 0 16.002 0C24.8375 0 32 7.16344 32 16C32 24.8366 24.8375 32 16.002 32C7.73871 32 0.847515 25.5662 0 17.5257H3.13795C3.13825 17.5286 3.13856 17.5314 3.13886 17.5343H7.2857V17.5446H9.19887C9.76244 20.7253 12.6359 22.7945 16.0017 22.7945C18.0798 22.7945 19.9386 21.8723 21.1922 20.4136L23.519 22.4137C21.7058 24.5236 19.0092 25.863 16.0017 25.863C12.2698 25.863 8.94137 23.6974 7.21988 20.6028H3.85629C5.67443 25.5108 10.4292 28.9315 16.002 28.9315C23.143 28.9315 28.9319 23.1419 28.9319 16C28.9319 8.85813 23.143 3.06849 16.002 3.06849Z","fill":"#1C1D20"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7046_253788"}},[_c('rect',{attrs:{"width":"32","height":"32","fill":"white"}})])])])
          )
        }
      }
    